import { useContext, useEffect, useState } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import ParamResultatEntrePrisePageModal from "pages/audit complet/situation professionnelle/modules/parametre resultat entreprise modal";
import Button from "components/ui/controls/button/button";
import { FaCalculator, FaCogs, FaSync, FaChartPie, FaCoins, FaShieldAlt, FaBuilding, FaPercentage, FaEuroSign } from "react-icons/fa";
import ParamImpotSocietePageModal from "pages/audit complet/situation professionnelle/modules/parametre impot societe modal";
import Modal from "components/ui/modal/modal";
import ParamImpotSociete from "./ParamImpotSociete";
import { CalculResultatEntreprise } from "components/app/Api/Remuneration/ApiRemuneration";
import "components/ui/controls/card-box/card-box.css";
import "components/ui/controls/text-field/text-field.css";
import ActionButton from "components/ui/controls/action-button/ActionButton";
import { createStyledButton } from "components/ui/controls/button/button-styles";

function Dividendes(props) {
  const context = useContext(AppContext);
  const [modalOpen, setmodalOpen] = useState(false);
  const Prenom = props.ClientConjoint === "" ? context.state.Prenom : context.state.PrenomConjoint;
  const PrenomConjoint = props.ClientConjoint !== "" ? context.state.Prenom : context.state.PrenomConjoint;
  useEffect(() => {
    if (context.state.SetSeuilAssuj === false) {
      CalculResultatEntreprise(context.state, "").then((ResultatEntreprise) => {
        context.handleValueChange("SeuilAssuj", ResultatEntreprise.SeuilAssuj);
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state.SetSeuilAssuj]);
  useEffect(() => {
    if (context.state.SetSeuilAssujConjoint === false) {
      CalculResultatEntreprise(context.state, "").then((ResultatEntreprise) => {
        context.handleValueChange("SeuilAssujConjoint", ResultatEntreprise.SeuilAssujConjoint);
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state.SetSeuilAssujConjoint]);

  // Fonction pour capitaliser chaque mot ou partie de prénom composé
  const capitalizePrenom = (str) => {
    if (!str || typeof str !== "string") return str || "";
    return str
      .split(/([ -])/)
      .map((s) => (/^[a-zA-ZÀ-ÿ]/.test(s) ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s))
      .join("");
  };

  return (
    <>
      <Column fill>
        <CardBox>
          <Column fill>
            <Row>
              <div className="dossier-header">
                <div className="dossier-header-icon">
                  <FaChartPie style={{ fontSize: "14px", color: "#6b7280" }} />
                </div>
                <div className="dossier-header-title">Détention capitalistique</div>
              </div>
            </Row>
            <Row style={{ marginTop: "16px" }}>
              <Column>
                <TextField
                  label="Capital social"
                  value={context.state.CapitalSocial}
                  onChange={context.handleInputChange("CapitalSocial")}
                  onBlur={(e) => {
                    context.handleCalculResultatEntreprise("", "CapitalSocial", e);
                  }}
                  xlarge
                  dataType="uint"
                  format={{ thousands: " ", unit: " €" }}
                />
              </Column>
            </Row>
            <Row style={{ marginTop: "24px" }}>
              <Column>
                <TextField
                  label={`Détention capitalistique ${capitalizePrenom(Prenom || "")}`}
                  labelStyle={{ textTransform: "none" }}
                  value={context.state.PartSoc}
                  onBlur={(e) => {
                    context.handleCalculResultatEntreprise("", "PartSoc", e);
                  }}
                  xlarge
                  dataType="ufloat"
                  format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                />
              </Column>
              {context.state.InclureConjoint && (
                <Column lpad>
                  <TextField
                    label={`Détention capitalistique ${capitalizePrenom(PrenomConjoint || "")}`}
                    labelStyle={{ textTransform: "none" }}
                    value={context.state.PartSocConj}
                    onBlur={(e) => {
                      context.handleCalculResultatEntreprise("", "PartSocConj", e);
                    }}
                    disabled={context.state.PartSoc === 100}
                    xlarge
                    dataType="ufloat"
                    format={{ thousands: " ", unit: "%", decimal: ",", precision: 2 }}
                  />
                </Column>
              )}
            </Row>
            <Row tpad>
              <div className="dossier-header">
                <div className="dossier-header-icon">
                  <FaCoins style={{ fontSize: "14px", color: "#6b7280" }} />
                </div>
                <div className="dossier-header-title">Résultat distribué</div>
              </div>
            </Row>
            {props.Outil === "" && (
              <>
                <Row style={{ marginTop: "16px" }}>
                  <Column>
                    <TextField
                      label={`Dividendes bruts ${context.state.InclureConjoint ? "du couple" : "pour " + context.state.Prenom}`}
                      value={context.state.DividendeBrut}
                      onBlur={(e) => {
                        context.handleCalculResultatEntreprise("", "DividendeBrut", e);
                      }}
                      disabled={"AccesModal" in props}
                      dataType="uint"
                      format={{ thousands: " ", unit: " €" }}
                      xlarge
                    />
                  </Column>
                </Row>
                <Row tpad>
                  <Column>
                    <ParamResultatEntrePrisePageModal Prenom={Prenom} PrenomConjoint={PrenomConjoint} />
                  </Column>
                </Row>
              </>
            )}
            {props.Outil !== "" && (
              <>
                <Row style={{ marginTop: "16px" }}>
                  <Column>
                    <TextField
                      value={context.state[props.Outil + "Reserve"]}
                      label="Mise en réserve"
                      onChange={context.handleInputChange(props.Outil + "Reserve")}
                      dataType="uint"
                      xlarge
                      format={{ thousands: " ", unit: " €" }}
                    />
                  </Column>
                </Row>
                {props.Outil === "RemExpress" && (
                  <Row tpad>
                    <Column>
                        <ActionButton
                        onClick={() => setmodalOpen(true)}
                        icon={FaCogs}
                        title="Paramétrage de l'IS"
                        style={{ maxWidth: "250px" }}
                      />
                      <Modal
                        width="40%"
                        height="43%"
                        title="Paramétrage de l'impôt sur les sociétés"
                        icon={<FaCogs />}
                        visible={modalOpen}
                        onClose={() => {
                          setmodalOpen(false);
                        }}
                      >
                        <ParamImpotSociete
                          onClose={() => {
                            setmodalOpen(false);
                          }}
                        />
                      </Modal>
                    </Column>
                  </Row>
                )}
                <Row tpad>
                  <div className="dossier-header">
                    <div className="dossier-header-icon">
                      <FaShieldAlt style={{ fontSize: "14px", color: "#6b7280" }} />
                    </div>
                    <div className="dossier-header-title">Régime social des dividendes</div>
                  </div>
                </Row>
                {props.Outil === "RemExpress" && (
                  <>
                   <Row >
                              <div
                                style={{
                                  backgroundColor: "white",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "12px",
                                  padding: "16px",
                                  width: "100%",
                                  minHeight: "96px",
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                                  marginBottom: "12px",
                                }}
                              >
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                    <div
                                      style={{
                                        width: "48px",
                                        height: "48px",
                                        borderRadius: "50%",
                                        backgroundColor: "#dbeafe",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <FaCalculator style={{ fontSize: "16px", color: "#3b82f6" }} />
                                    </div>
                                    <div>
                                      <div style={{ fontSize: "12px", fontWeight: "600", color: "#1f2937", marginBottom: "2px" }}>Seuil d'assujetissement pour {context.state.Prenom}</div>
                                      <div style={{ fontSize: "12px", color: "#6b7280" }}>{context.state.SetSeuilAssuj === false ? "Calculé automatiquement" : "Saisi manuellement"}</div>
                                    </div>
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Button
                                      tabIndex="-1"
                                      icon
                                      onClick={() => context.handleValueChange("SetSeuilAssuj", false)}
                                      {...createStyledButton("card-action", "cardEdit", { backgroundColor: "#dbeafe" })}
                                    >
                                      {context.state.SetSeuilAssuj === false ? (
                                        <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} />
                                      ) : (
                                        <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                                      )}
                                    </Button>
                                    <TextField
                                      value={context.state.SeuilAssuj}
                                      onChange={(e) => {
                                        context.handleValueChange("SetSeuilAssuj", true);
                                        context.handleValueChange("SeuilAssuj", e.target.value);
                                      }}
                                      dataType="uint"
                                      format={{ thousands: " ", unit: " €" }}
                                      small
                                      style={{ minWidth: "80px",fontSize: "12px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Row>
                  </>
                )}
              </>
            )}
          </Column>
        </CardBox>
      </Column>
    </>
  );
}

export default Dividendes;
